import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Alert, Modal, ModalBody, ModalHeader} from "reactstrap";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import {Accordion} from "react-bootstrap";
import useDidMountEffect from "../../../utils/useDidMountEffect";
import apiUser from "../../../apiUser";
import WiringAccordion from "./WiringAccordion";
import {isArray} from "lodash";
import useAfterUpdateEffect from "../../../utils/useAfterUpdateEffect";
import FuseRelaisAccordion from "./FuseRelaisAccordion";
import DiagnosticsAccordion from "./DiagnosticsAccordion";
import {useTecRmi} from "../../../contexts/TecRmiContext";

const LinkedModal = props => {
  const { getApiPrimaryParams } = useTecRmi()
  const [loading, setLoading] = useState(false)
  const [wiringDiagrams, setWiringDiagrams] = useState([])
  const [fuseRelayComponent, setFuseRelayComponent] = useState()
  const [fuseRelais, setFuseRelais] = useState([])
  const [diagnosticComponent, setDiagnosticComponent] = useState()
  const [diagnostics, setDiagnostics] = useState([])

  useDidMountEffect(() => {
    setLoading(true)

    Promise.all([
      props.wiringDiagramsFn && props.wiringDiagramsFn({
        ...getApiPrimaryParams(),
        itemMpId: props.id,
      }).then(res => setWiringDiagrams(isArray(res.data) ? res.data : [res.data])),

      props.fuseRelaisFn && apiUser.tecRmi.relaysFuses.componentsForType(getApiPrimaryParams())
        .then(res => {
          const componentTypeId = res.data[0].ComponentTypeId;
          setFuseRelayComponent(componentTypeId)
          fetchLinkedFuseRelais(componentTypeId)
          return res
        }),

      props.diagnosticsFn && apiUser.tecRmi.diagnostics.componentsForType(getApiPrimaryParams())
        .then(res => {
          const componentTypeId = res.data[0].ComponentTypeId;
          setDiagnosticComponent(componentTypeId)
          fetchLinkedDiagnostics(componentTypeId)

          return res
        }),
    ])
      .then(() => setLoading(false))
  })

  useAfterUpdateEffect(() => {
    fetchLinkedFuseRelais(fuseRelayComponent)
  }, [fuseRelayComponent])

  useAfterUpdateEffect(() => {
    fetchLinkedDiagnostics(diagnosticComponent)
  }, [diagnosticComponent])

  const fetchLinkedFuseRelais = (componentTypeId) => {
    return props.fuseRelaisFn({
      ...getApiPrimaryParams(),
      linkId: props.id,
      componentTypeId,
    })
      .then(res => setFuseRelais(isArray(res.data) ? res.data : [res.data]))
  }

  const fetchLinkedDiagnostics = (diComponentTypeId) => {
    return props.diagnosticsFn({
      ...getApiPrimaryParams(),
      diItemId: props.id,
      itemMpId: props.id,
      diComponentTypeId,
    })
      .then(res => setDiagnostics(isArray(res.data) ? res.data : [res.data]))
  }

  return (
    <Modal isOpen size={'xl'} toggle={props.onClose} className="modal-w-100">
      <ModalHeader toggle={props.onClose}>Powiązania</ModalHeader>
      <ModalBody>
        {
          loading
            ? <LoadingSpinner/>
            : <React.Fragment>
              <Accordion>
                {wiringDiagrams.length > 0 && <WiringAccordion wiringDiagrams={wiringDiagrams} />}
                {fuseRelais.length > 0 && <FuseRelaisAccordion fuseRelayComponent={fuseRelayComponent} onFuseRelayComponentChange={setFuseRelayComponent} fuseRelais={fuseRelais} />}
                {diagnostics.length > 0 && <DiagnosticsAccordion diagnosticComponent={diagnosticComponent} onDiagnosticComponentChange={setDiagnosticComponent} diagnostics={diagnostics} />}
              </Accordion>
              {(wiringDiagrams.length === 0 && fuseRelais.length === 0 && diagnostics.length === 0) && <Alert color={'warning'} className="text-center">Brak powiązań</Alert>}
            </React.Fragment>
        }
      </ModalBody>
    </Modal>
  );
};

LinkedModal.propTypes = {
  wiringDiagramsFn: PropTypes.func,
  fuseRelaisFn: PropTypes.func,
  diagnosticsFn: PropTypes.func,
};

export default LinkedModal;